import React from "react";
import { useNavigate } from "react-router-dom";
import UtilsUnit from "../../../utils/UtilsUnit";
import ConstantsImages from "../../../constants/ConstantsImages";
import WidgetIcon from "../../icons/widget-icon/WidgetIcon";
import WidgetTooltipWrapper from "../widget-tooltip-wrapper/WidgetTooltipWrapper";
import ConstantsTexts from "../../../constants/ConstantsTexts";

const WidgetDashboardIcon = ({ editMode = false }) => {
  const navigate = useNavigate();

  const backgroundColor = editMode ? "#696E83" : "#2e2e2e";
  const cursor = editMode ? "default" : "pointer";

  return (
    <WidgetTooltipWrapper content={ConstantsTexts.CODE_164}>
      <WidgetIcon
        iconProp={ConstantsImages.BUS_IMAGE}
        widthIconProp="2.1rem"
        heightIconProp="1.4rem"
        backgroundColorProp={backgroundColor}
        cursorProp={cursor}
        handleOnClickProp={() => UtilsUnit.handleBusFrameClick(navigate, editMode)}
        customClassNameProp="widget-dashboard-icon"
        dataHoverDisabled={editMode}
      />
    </WidgetTooltipWrapper>
  );
};

export default WidgetDashboardIcon;
